import { render, staticRenderFns } from "./mealDay.vue?vue&type=template&id=664d40cf&scoped=true&"
import script from "./mealDay.vue?vue&type=script&lang=js&"
export * from "./mealDay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664d40cf",
  null
  
)

export default component.exports